import ADMIN_PERMISSIONS from '@/constants/authorization/admin-permissions'

export default [
  {
    header: 'navigation.settings',
  },
  {
    title: 'navigation.addons',
    route: 'super:addons',
    adminPermissions: [ADMIN_PERMISSIONS.ACCOUNTS],
    icon: 'CreditCardIcon',
  },
  {
    title: 'integrations.integrations',
    adminPermissions: [ADMIN_PERMISSIONS.INTEGRATIONS],
    icon: 'Link2Icon',
    children: [
      {
        title: 'integrations.integrations',
        route: 'super:integrations',
        hideIcon: true,
      },
      {
        title: 'integrations.integrations-categories',
        route: 'super:integration-categories',
        hideIcon: true,
      },
      {
        title: 'integrations.integration-connections',
        route: 'super:integration-connections',
        hideIcon: true,
      },
    ],
  },
  {
    title: 'mobile.mobile-section',
    icon: 'AndroidIcon',
    children: [
      {
        title: 'mobile.account.page-title',
        route: 'super:mobile-accounts',
        hideIcon: true,
      },
      {
        title: 'mobile.settings.page-title',
        route: 'super:mobile-settings',
        hideIcon: true,
      },
    ],
  },
]
